<template>
  <span :class="badgeClasses">
    {{ status === 'signed' ? 'Signed' : 'Draft' }}
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: {
    type: String,
    default: 'draft',
    validator: (value) => value === null || ['draft', 'signed'].includes(value)
  }
});

const badgeClasses = computed(() => {
  const base = 'inline-flex items-center justify-center h-6 w-[80%] min-w-[48px] px-[15px] py-2 rounded-[23px] text-[12px] font-medium tracking-[0.4px] leading-[17px]';
  
  if (props.status === 'signed') {
    return `${base} bg-[#e5f9ef] border border-[#e5f9ef] text-[#20a7c1]`;
  }
  
  return `${base} bg-[#e0e0e0] border border-[#e0e0e0] text-[#666]`;
});
</script>

<style scoped>
span {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
}
</style>
